export default function AutresMarques() {
  return (
    <section className="bg-brand-light py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <h2 className="text-2xl md:text-3xl font-bold text-brand-blue mb-6">
          Les autres marques que nous traitons
        </h2>
        <p className="text-brand-text leading-relaxed mb-5">
          Notre équipe intervient sur l'ensemble des moteurs du marché au-delà de la marque Profalux. Nous remplaçons régulièrement des moteurs Somfy, Nice, Bubendorff, Faac, Came, Simu et Becker. Chaque constructeur possède des spécificités distinctes : Somfy domine avec ses protocoles RTS et IO-Homecontrol, Nice est apprécié pour sa robustesse sur les grandes baies vitrées, et Bubendorff se distingue par ses moteurs intégrés aux tabliers avec alimentation solaire. Cette expertise multi-marques nous permet d'offrir des solutions alternatives lorsqu'un moteur Profalux d'origine n'est plus commercialisé.
        </p>
        <p className="text-brand-text leading-relaxed mb-8">
          Pour les clients qui possèdent des volets de différentes marques dans leur habitation, nous proposons une homogénéisation des commandes. Par exemple, un propriétaire peut avoir des volets Profalux à l'arrière et des volets Somfy à l'avant. Nous installons alors des modules de commande universels qui permettent de piloter l'ensemble des volets depuis une seule télécommande ou une application domotique. Notre stock de pièces détachées couvre les principales gammes de moteurs, ce qui minimise les délais d'attente et garantit une réparation dans la journée pour la plupart des interventions.
        </p>

        <h3 className="text-xl font-semibold text-brand-blue mb-4">
          Marques couvertes par notre service
        </h3>
        <ul className="space-y-3">
          {[
            "Moteurs Somfy : remplacement et reprogrammation RTS / IO-Homecontrol",
            "Moteurs Nice : diagnostic et changement pour volets lourds et grandes baies",
            "Moteurs Bubendorff : intervention sur systèmes à moteur intégré et batteries solaires",
            "Moteurs Faac, Came et Simu : remplacement avec conservation des commandes existantes",
            "Moteurs universels compatibles : solution économique pour installations anciennes",
            "Migration multi-marques : centralisation des commandes sous un protocole unique",
          ].map((item) => (
            <li key={item} className="flex items-start gap-3">
              <span className="w-5 h-5 flex items-center justify-center text-brand-cyan mt-0.5 flex-shrink-0">
                <i className="ri-checkbox-circle-line text-lg"></i>
              </span>
              <span className="text-brand-text text-sm md:text-base">{item}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}